import { HEIGHT_CONTROL_PANEL_UUID, HEIGHT_CONTROL_PANEL_WIDTH } from '../constants';
import { Article, ArticleDefinition } from '../interfaces/Article';
import { Slot, SlotLine } from '../interfaces/Slot';
import { SlotType } from '../interfaces/SlotDefinition';
import { ArticleInstanceId } from '../interfaces/Uuid';

export default class SlotService {
  static isSlotAvailableForArticle = (
    slot: Slot,
    articles: Article[],
    article: ArticleDefinition,
  ): boolean => {
    if (slot.type !== SlotType.LINE) {
      return SlotService.isSlotAvailable(slot);
    }

    const occupiedSpace = SlotService.calculateSlotLineOccupiedSpace(slot, articles);
    return article.width ? slot.definition.length >= occupiedSpace + article.width : false;
  };

  static isSlotAvailable = (slot: Slot): boolean => {
    if (slot.blockedBy) {
      return false;
    }

    if (slot.type === SlotType.LINE) {
      return true;
    }

    return !slot.childId;
  };

  static isSlotOccupied = (slot: Slot) => {
    return slot.type === SlotType.LINE ? slot.children.length > 0 : !!slot.childId;
  };

  static slotHasChild = (slot: Slot, id: ArticleInstanceId) => {
    if (slot.type === SlotType.LINE) {
      return slot.children.map((child) => child.id).includes(id);
    }

    return slot.childId === id;
  };

  static detachArticleFromSlot = (slot: Slot, article: Article): Slot => {
    if (slot.type !== SlotType.LINE && slot.childId === article.id) {
      return { ...slot, childId: undefined };
    }
    if (slot.type === SlotType.SINGLE && slot.blockedBy === article.id) {
      return { ...slot, blockedBy: undefined };
    }
    return slot;
  };

  static calculateSlotLineOccupiedSpace = (slotLine: SlotLine, articles: Article[]): number => {
    return slotLine.children
      .map((child) => {
        if (child.id === HEIGHT_CONTROL_PANEL_UUID) {
          return HEIGHT_CONTROL_PANEL_WIDTH;
        }
        const articleWidth = articles.find((article) => article.id === child.id)?.definition?.width;
        if (!articleWidth) {
          throw new Error(`Article ${child.id} is not present in the store!`);
        }
        return articleWidth;
      })
      .reduce((a, b) => a + b, 0);
  };
}
